<template>
  <div class="notice-popup-content">
    <p class="notice-popup-content_title">
      {{ title }}
    </p>
    <div class="notice-popup-content_list">
      <div
        v-for="(item,itemIndex) in noticeList"
        :key="itemIndex"
        class="notice-popup-content_list-item"
      >
        <i
          :class="noticeIcon"
          class="list-item-icon"
        />
        <p class="list-item-text">
          {{ $t(item.text) }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NoticePopupContent",
  props: {
    title: {
      type: String,
      default: "",
    },
    noticeList: {
      type: Array,
      default() {
        return [];
      },
    },
    noticeIcon: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/notice-popup-content";
</style>